import FacebookIcon from "../assets/facebook.svg";
import InstagramIcon from "../assets/instagram.svg";
import LinkedInIcon from "../assets/linkedin.svg";
import TiktokIcon from "../assets/tik_tok.svg";
import TwitchIcon from "../assets/twitchFooter.svg";
import XIcon from "../assets/x.svg";
import YoutubeIcon from "../assets/youtube.svg";

export const FOOTER_LINK_GROUPS = [
  {
    id: "support",
    title: "Support",
    links: [
      { label: "FAQ", href: "/faq" },
      { label: "Refunds & Returns", to: "/return-policy" },
      { label: "Contact Us", to: "/Contact" },
      { label: "Where's My Order?", to: "/wheres-my-order" },
    ],
  },
  {
    id: "company",
    title: "Company",
    links: [
      { label: "Blog", href: "https://blog.streamily.com" },
      { label: "Sitemap", href: "/sitemap.html" },
      {
        label: "We're Hiring",
        href: "https://www.indeed.com/cmp/Smashnet/jobs",
      },
    ],
  },
];

export const SOCIAL_LINKS = [
  {
    id: "instagram",
    label: "Instagram",
    href: "https://instagram.com/streamily.live",
    icon: InstagramIcon,
    external: true,
  },
  {
    id: "x",
    label: "X",
    href: "https://twitter.com/StreamilyLive",
    icon: XIcon,
    external: true,
  },
  {
    id: "youtube",
    label: "YouTube",
    href: "https://youtube.com/streamily",
    icon: YoutubeIcon,
    external: true,
  },
  {
    id: "facebook",
    label: "Facebook",
    href: "https://www.facebook.com/Streamily",
    icon: FacebookIcon,
    external: true,
  },
  {
    id: "tiktok",
    label: "TikTok",
    href: "https://www.tiktok.com/@streamilylive",
    icon: TiktokIcon,
    external: true,
  },
  {
    id: "twitch",
    label: "Twitch",
    href: "https://www.twitch.tv/streamilylive",
    icon: TwitchIcon,
    external: true,
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/streamily/posts/?feedView=all",
    icon: LinkedInIcon,
    external: true,
  },
];

export const FOOTER_ACTIONS = [
  {
    id: "talent",
    label: "Join as Talent",
    to: "/talent/signup",
    variant: "filled",
  },
  {
    id: "affiliate",
    label: "Become an Affiliate",
    href: "https://landing.streamily.com/affiliate",
    variant: "tonal",
  },
];

export const LEGAL_LINKS = [
  { label: "Terms and Conditions", to: "/terms-and-conditions" },
  { label: "Privacy Policy", to: "/privacy-policy" },
];

const FOOTER_HIDDEN_PREFIXES = ["/dashboard", "/signing-studio"];

const isWithin = (path) => (prefix) =>
  path === prefix || path.startsWith(`${prefix}/`);

export const isFooterVisible = (pathname) => {
  const path = pathname.toLowerCase();
  return !FOOTER_HIDDEN_PREFIXES.some(isWithin(path));
};
